export default __webpack_public_path__ + "static/media/question-notifier.79a47446.svg";